import type { BuyerFundingFlowSession } from "../flows/buyerFunding/types";
import { BuyerSecuredBankDetailsDocument } from "./BuyerSecuredBankDetailsDocument";

type Props = {
  session: BuyerFundingFlowSession;
  downloaded: boolean;
  onDownload: () => void;
  onContinue: () => void;
};

export function BuyerDownloadInstructionsStep({ session, downloaded, onDownload, onContinue }: Props) {
  return (
    <div className="grid min-w-0 gap-3" data-testid="buyer-download-screen">
      <button
        className="button-primary w-full"
        data-testid="buyer-download-instructions"
        type="button"
        onClick={onDownload}
      >
        Download secured details
      </button>
        {downloaded ? (
          <button className="button-secondary w-full" data-testid="buyer-download-continue" type="button" onClick={onContinue}>
            Continue
          </button>
        ) : null}

      <div className="hidden">
        <BuyerSecuredBankDetailsDocument session={session} />
      </div>
    </div>
  );
}
